import React from 'react';
import { View } from 'react-native';
import moment from 'moment';

import { machineStatusName, subStatusName, convertTimeLetter, formatTimeEvent, formatSinceTime } from '@helpers';
import Line from '@components/common/line';

import NcFileIcon from './NCFileIcon';
import { EventDetailsActiveProps } from '@v2/pages/machines/common/types/event';
import { StartEndTime } from '@v2/pages/machines/modules/events/components/combined/CombinedEventComponent';

export default ({ C, selectedItem, setShowEditTime, eventInfo, NCFileInfo, onNcDetailsClick }: EventDetailsActiveProps) => {
  const time = convertTimeLetter(eventInfo.durationInMilliseconds, true);

  const config = [
    { name: 'Status', value: machineStatusName[eventInfo.status as keyof typeof machineStatusName], noArrow: true },
    { name: 'Substatus', value: subStatusName[eventInfo.subStatus as keyof typeof subStatusName] || ' ', noArrow: true },
    { name: 'Execution Mode', value: eventInfo.executionMode || ' ', noArrow: true },
    {
      name: 'Runtime',
      value: formatTimeEvent(time, false),
      secondName: 'Target Runtime',
      secondValue: formatTimeEvent(convertTimeLetter(NCFileInfo.runTimePerPcsSecond), false),
      noArrow: false,
      onClick: () => setShowEditTime({ runtimePerPiece: { h: Number(time.h), m: Number(time.m), s: Number(time.s) } }),
    },
    eventInfo.ncFileActive
      ? {
          name: 'NC File Running',
          value: eventInfo.ncFileActive,
          noArrow: false,
          onClick: () => eventInfo.ncFileActive && onNcDetailsClick(eventInfo.ncFileActive),
          ValueIcon: () => <NcFileIcon {...{ C, ncFileStatus: eventInfo.ncFileStatusActive }} />,
        }
      : null,
    eventInfo.ncFileVersionSequenceNumberActive
      ? {
          name: 'NC File Running Version',
          value: eventInfo.ncFileVersionSequenceNumberActive,
          noArrow: true,
        }
      : null,
    {
      name: 'NC File Selected',
      value: eventInfo.ncFileSelected || '-',
      noArrow: true,
      onClick: () => eventInfo.ncFileActive && onNcDetailsClick(eventInfo.ncFileActive),
      ValueIcon: () => <NcFileIcon {...{ C, ncFileStatus: eventInfo.ncFileStatusSelected }} />,
    },
    {
      name: 'NC File Selected Version',
      value: eventInfo.ncFileVersionSequenceNumberSelected || '-',
      noArrow: true,
    },
    { name: 'Machine', value: selectedItem.fullName, noArrow: true },
    { name: 'Start Time', ValueComponent: <StartEndTime dateTime={eventInfo.startedOn} C={C} />, noArrow: true },
    {
      name: 'End Time',
      ValueComponent: (
        <StartEndTime dateTime={moment.utc(eventInfo.startedOn).add(eventInfo.durationInMilliseconds, 'milliseconds').format()} C={C} />
      ),
      noArrow: true,
    },
    {
      name: 'Raw Execution Mode',
      value: eventInfo.rawExecutionMode || ' ',
      noArrow: true,
    },
    {
      name: 'Raw Substatus',
      value: eventInfo.rawSubStatus || ' ',
      noArrow: true,
    },
  ];

  const filteredConfig = config.filter((i) => i);
  return (
    <View
      style={{
        width: '100%',
      }}
    >
      {filteredConfig.map((item, index) => (
        <Line
          {...{
            inverted: true,
            bigSize: true,
            item,
            index,
            array: filteredConfig,
            C,
            roundTop: index === 0,
            roundBottom: index === filteredConfig.length - 1,
          }}
          key={item?.name}
        />
      ))}
    </View>
  );
};
